<template>
    <v-layout justify-center align-center>
        <v-flex xs12 sm6>
            <v-alert v-if="errors" :value="true" type="error">
                {{errors}}
            </v-alert>

            <v-stepper v-model="importStep" vertical v-if="!processing">
                <v-stepper-step :complete="importStep > 1" step="1">
                    Select award type
                    <small>Select which awards you want to import categories for</small>
                </v-stepper-step>

                <v-stepper-content step="1">
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-text-field
                                v-model="importJobConfig.params.year"
                                :rules="yearRules"
                                label="Award Year"
                                :mask="'####'"
                                required
                        ></v-text-field>
                        <v-select
                                v-model="importJobConfig.params.type"
                                :items="entryTypes"
                                :rules="[v => !!v || 'Award Type is required']"
                                label="Award Type"
                                required
                        ></v-select>
                    </v-form>
                    <v-btn color="primary" :disabled="!valid" @click="verifyFirstStep">Continue</v-btn>
                </v-stepper-content>

                <v-stepper-step :complete="importStep > 2" step="2">
                    Upload categories
                </v-stepper-step>

                <v-stepper-content step="2">
                    <!--TODO: warn that footnotes should *not* be included-->
                    <!--TODO: upload form for spreadsheet-->
                    <!--TODO: check that it is xlsx-->
                    <!--Validate the structure?-->
                    <v-card color="grey lighten-1" class="mb-2">
                        <input
                                ref="targetFile"
                                :rules="uploadRules"
                                type="file"
                                required
                                @change="processFile"
                        />
                    </v-card>
                    <v-btn color="primary" :disabled="!fileSelected" @click="uploadImport">Upload</v-btn>
                </v-stepper-content>

                <v-stepper-step :complete="importStep > 3" step="3">
                    Confirm
                </v-stepper-step>

                <v-stepper-content step="3">
                    <h2>Are you sure you want to run this import?</h2>
                    <p>Doing so will overwrite any existing categories that have been configured for this award type.</p>
                    <v-btn color="primary" :disabled="!fileSelected || !valid" @click="submitJob">Start Import</v-btn>
                </v-stepper-content>

            </v-stepper>
            <loading v-else></loading>
        </v-flex>
    </v-layout>
</template>

<script>
  // TODO: change this to load a list of available awards foro which we can import cats for
  export default {
    name: 'dataops-imports-categories',
    props: {
      firebaseUser: {
        required: true
      },
      user: {
        required: true
      },
      systemConfig: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      importStep: 1,
      processing: false,
      processingMessage: '',
      errors: null,
      jobConfig: {
        importName: 'categories',
        params: {
          year: 0,
          type: 'GT',
          importFileName: null
        }
      },
      valid: true,
      yearRules: [
        v => !!v || 'Entry Year is required',
        v => (v && /^[0-9]{4}$/.test(v)) || 'Entry Year must be formatted YYYY e.g. 2018'
      ],
      entryTypes: [
        'GT',
        'WC'
      ],
      uploadValid: false,
      uploadRules: [
        v => !!v || 'File name is required',
        v => (v && /^.{3,145}\.xlsx$/.test(v)) || 'File name must be at most 150 characters, and end in ".xlsx"'
      ],
      targetFilePath: null,
      fileSelected: false,
      fileToUpload: null
    }),
    created () {
      const todaysDate = new Date()
      this.jobConfig.params.year = todaysDate.getFullYear()
    },
    methods: {
      verifyFirstStep () {
        const self = this
        if (self.$refs.form.validate()) {
          self.importStep = 2
        }
      },
      processFile (event) {
        console.log(event)
        if (event.target.files[0]) {
          this.fileToUpload = event.target.files[0]
          this.fileSelected = true
        } else {
          this.fileToUpload = null
          this.fileSelected = false
        }
      },
      uploadImport () {
        const self = this

        if (self.$refs.form.validate()) {
          const file = self.fileToUpload
          const userUID = self.firebaseUser.uid
          // Create a reference where we can upload the file
          // const uploadRef = self.$firebaseClient.firebaseStorageRef.child('imports').child('categories').child(userUID).child(file.name)
          const targetPath = `gs://${self.$firebaseClient.firebaseInstance.options.projectId}/imports/categories/${userUID}/${file.name}`
          const uploadRef = self.$firebaseClient.firebaseInstance.storage().refFromURL(targetPath)
          // Start the upload
          const uploadTask = uploadRef.put(file)
          // Listen for state changes, errors, and completion of the upload.
          uploadTask.on('state_changed',
            (snapshot) => {
              // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
              const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
              console.log(`Upload is ${progress}% done`)
              switch (snapshot.state) {
                case 'paused':
                  console.log('Upload is paused')
                  break
                case 'running':
                  console.log('Upload is running')
                  break
                default:
                  console.log(`Upload is ${snapshot.state}`)
              }
            }, (error) => {
              // A full list of error codes is available at
              // https://firebase.google.com/docs/storage/web/handle-errors
              switch (error.code) {
                case 'storage/unauthorized':
                  // User doesn't have permission to access the object
                  break
                case 'storage/canceled':
                  // User canceled the upload
                  break
                case 'storage/unknown':
                  // Unknown error occurred, inspect error.serverResponse
                  break
                default:
                  console.log(`Upload error ${error.code}`)
              }
            }, () => {
              // Upload succeeded; save file name and move to next step
              self.jobConfig.params.importFileName = file.name
              console.log('complete')
              self.importStep = 3
            }
          )
        }
      },
      submitJob () {
        // Modify to work in two stages; upload the file and then submit the job config
        // TODO: send just the file name. We then construct the file path on the server using the user UID. This ensures
        // that only files uploaded by the user can be used. Uploads are only allowed for admins; if an admin uploads a
        // malicious file then it's game over.
        const self = this
        if (self.$refs.uploadForm.validate()) {
          console.log('Valid config; submitting')

          self.processingMessage = 'Submitting import job'
          self.errors = null
          self.processing = true

          self.$firebaseClient.executeRTDBCommand('admin.dataops.import', self.jobConfig)
            .then((responseRef) => {
              if (responseRef) {
                responseRef.on('value', (responseSnapshot) => {
                  console.log('[FIREBASE_COMMAND]: Command status has updated')
                  const response = responseSnapshot.val()
                  if (response) {
                    if (response.success) {
                      console.log('[FIREBASE_COMMAND]: Import successfully started')
                      self.processingMessage = 'Import started; loading status'
                      if (response.hasOwnProperty('detailed') && response.detailed.hasOwnProperty('jobUID')) {
                        self.$router.push({name: 'dataops.jobs.read', params: {jobUID: response.detailed.jobUID}})
                      }
                    } else {
                      console.log(`[FIREBASE_COMMAND]: Import failed to execute: ${response.message}`)
                      self.errors = response.message
                      self.processingMessage = ''
                      self.processing = false
                      self.running = true
                    }
                  }
                })
              }
            })
            .catch((error) => {
              console.log(error.message)
              self.processing = false
              self.processingMessage = ''
            })
        }
      }
    }
  }
</script>

<style lang="scss">
</style>
